module.exports = __webpack_public_path__ + "assets/img/ArtyWilmotte_Wilmotte.9c333f7f-ps.jpg";